import axios from 'axios'
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useAuth } from '../AuthContext';
import { NavLink, useNavigate } from 'react-router-dom';
import SkelotonEffect from './SkelotonEffect';
import Blogs from './Blogs';
import Calendar from './Calendar';
import Banner from './Banner';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


/* import { FaLink } from 'react-icons/fa'; */
import { IoArrowBack, IoArrowForward } from 'react-icons/io5';


export default function Home() {
    const { isAuthenticated } = useAuth();
    const userId = localStorage.getItem('userid');
    const [firstObject, setFirstObject] = useState(null);
    const [secondObject, setSecondObject] = useState(null);
    const [thirdObject, setThirdObject] = useState(null);
    const [fourthObject, setFourthObject] = useState(null);
    const [fifthObject, setFifthObject] = useState(null);
    const [sixObject, setSixObject] = useState(null);
    /*  const [sevenObject, setSevenObject] = useState(null); */
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedBook, setSelectedBook] = useState(null);
    const [error, setError] = useState(null);
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;

    const navigate = useNavigate();

    

    useEffect(() => {
        axios.get(`${baseURL}/homedata/?userid=${userId}&limit=10`, {

            headers: {
                'accept': 'application/json',
                'Authorization': apiKey,

            }
        })
            .then((response) => {

                /*  setData(response.data) */
                if (response.data.length > 0) {
                    const firstItem = response.data[0];
                    /*  console.log(firstItem)  */
                    setFirstObject(firstItem);
                    const secondItem = response.data[1];

                    setSecondObject(secondItem);
                    const thirdItem = response.data[2];
                    /*  console.log(secondItem) */
                    setThirdObject(thirdItem);
                    const fourthItem = response.data[3];
                    /* console.log(fourthItem)  */
                    setFourthObject(fourthItem);
                    const fifthItem = response.data[4];
                    /* console.log(fifthItem)  */
                    setFifthObject(fifthItem);
                    const sixthItem = response.data[5];

                    setSixObject(sixthItem);
                    /*  console.log(response.data[5])  */

                    /* 
                                        const seventhItem = response.data[0];
                                        setSevenObject(seventhItem); */
                    /* console.log(response.data[0])  */
                }

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setError(error);
            })
            .then(() => {
                setIsLoading(false); // Set loading state to false when request completes
            });

    }, [userId, baseURL, apiKey])

    const openModal = (datav) => {
        setSelectedBook(datav);
        setShowModal(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
        setSelectedBook(null); // Reset selected book when closing modal
    };



    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
    }, []);
    




    const handleClicknew = () => {

        const fileLink = selectedBook.book_link;
        const fileExtension = fileLink.split('.').pop();

        if (fileExtension === 'pdf') {
            navigate('/pdf', { state: { message: fileLink } });
        } else if (fileExtension === 'epub') {
            navigate('/epub', { state: { message: fileLink } });
        } else {
            console.error('Unsupported file type');
        }
    };

    const handleAgeGroupClick = (ageGroup, ageGroupID) => {
        navigate('/age-group-books', { state: { ageGroup, ageGroupID } });
    };

    const handleGenreClick = (genreID) => {
        navigate('/genre-books', { state: { genreID } });
    };

    const handleLanguageClick = (languageID) => {
        navigate('/language-books', { state: { languageID } });
    };




    const settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        arrows: true,
        speed: 800,
        slidesToShow: 7,
        slidesToScroll: 1,
        prevArrow: <IoArrowBack className="icofont-arrow-right dandik" />,
        nextArrow: <IoArrowForward className="icofont-arrow-left bamdik" />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: true,
                }
            },

        ]
    };



    /*  const [modalShow, setModalShow] = useState(false); */
    const [modalImage, setModalImage] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const images = [
        {
            src: "assets/images/gallery/Gallery_1.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_2.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_3.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_4.jpg",
            title: "Another alt text"
        },

        {
            src: "assets/images/gallery/Gallery_5.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_6.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_7.jpeg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_8.jpeg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_9.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_10.jpg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_11.jpeg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_12.jpeg",
            title: "Another alt text"
        },
        {
            src: "assets/images/gallery/Gallery_13.jpg",
            title: "Another alt text"
        },

    ];



    const openModalg = (index) => {
        setModalImage(images[index].src);
        setModalTitle(images[index].title);
        setCurrentIndex(index);
        const modalElement = document.getElementById('image-gallery');
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
    };



    const showPreviousImage = () => {
        const newIndex = (currentIndex - 1 + images.length) % images.length;
        setModalImage(images[newIndex].src);
        setModalTitle(images[newIndex].title);
        setCurrentIndex(newIndex);
    };

    const showNextImage = () => {
        const newIndex = (currentIndex + 1) % images.length;
        setModalImage(images[newIndex].src);
        setModalTitle(images[newIndex].title);
        setCurrentIndex(newIndex);
    };


    const renderStars = (rating) => {
        const fullStars = Math.floor(rating); // Full stars (e.g., for 4.5, this is 4)
        const halfStar = rating % 1 >= 0.5;   // True if there's a half star (e.g., for 4.5, this is true)
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0); // Remaining empty stars to make a total of 5 stars

        return (
            <>
                {/* Render full stars */}
                {Array.from({ length: fullStars }, (_, i) => (
                    <i key={`full-${i}`} className="active icofont-star"></i>
                ))}

                {/* Render half star if applicable */}
                {halfStar && <i className="half icofont-star"></i>}

                {/* Render empty stars */}
                {Array.from({ length: emptyStars }, (_, i) => (
                    <i key={`empty-${i}`} className="inactive icofont-star"></i>
                ))}
            </>
        );
    };


    const handleActionClick = () => {
        if (!isAuthenticated) {
            handleReadMoreClick();  // User is not logged in, redirect to login page
        } else {
            handleClicknew();  // User is logged in, proceed with file handling
        }
    };
    const handleReadMoreClick = () => {
        navigate('/login');  // Redirect to login page when clicked
    };


    



    return (
        <>

           


            <Banner />

            {selectedBook && (
                <>
                    <div className="modal " style={{ display: showModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000" >
                                <button className="modal-close icofont-close" onClick={closeModal}></button>
                                <div className="product-view">

                                    <div className="col-md-12 col-lg-12">
                                        <div className="row view-gallery">
                                            <div className='col-md-12'>
                                                <h3 className="view-name">
                                                    {selectedBook.book_title}
                                                </h3>
                                            </div>
                                            <div className='col-md-4'>
                                                <img src={!selectedBook.book_cover_img ? "https://ndl.education.gov.in/upload/book_place_holder.jpg" : selectedBook.book_cover_img} alt="Book Cover" className="img-fluid mb-3 w-100" />
                                            </div>
                                            <div className='col-md-8'>
                                                <div className='row'>

                                                    <div className='col-md-12'>
                                                        <div className="table_modal">
                                                            <div className="info-authors">
                                                                {selectedBook.author_name && (
                                                                    <>
                                                                        <h4 className="info-ttl">Authors </h4>
                                                                        <h4 className="info-ans">{selectedBook.author_name}</h4>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.publisher_name && (
                                                                    <>
                                                                        <h4 className="info-ttl">publisher </h4>
                                                                        <h4 className="info-ans">{selectedBook.publisher_name}</h4>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {!!selectedBook.avg_rating && (
                                                                    <>
                                                                        <h4 className="info-ttl">Average Rating </h4>
                                                                        <h4 className="info-ans">{selectedBook.avg_rating.toFixed(1)}</h4>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.book_pages && (
                                                                    <>
                                                                        <h4 className="info-ttl">Total Number of pages </h4>
                                                                        <h4 className="info-ans">{selectedBook.book_pages}</h4>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.book_year && (
                                                                    <>
                                                                        <h4 className="info-ttl">Book Year </h4>
                                                                        <h4 className="info-ans">{selectedBook.book_year}</h4>
                                                                    </>
                                                                )}
                                                            </div>


                                                            <div className="info-authors">
                                                                {selectedBook.category_name && (
                                                                    <>
                                                                        <h4 className="info-ttl">Book Category Name </h4>
                                                                        <h4 className="info-ans">{selectedBook.category_name}</h4>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.download_count && (
                                                                    <>
                                                                        <h4 className="info-ttl">Download Count </h4>
                                                                        <h4 className="info-ans">{selectedBook.download_count}</h4>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="info-authors ">
                                                                {selectedBook.language && (
                                                                    <>
                                                                        <h4 className="info-ttl">Language </h4>
                                                                        <h4 className="info-ans">{selectedBook.language}</h4>
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div className="info-authorss ">
                                                                <button onClick={handleActionClick} className='btn-6 view-all-btnn mt-3'>Read <i className="fas fa-long-arrow-alt-right"></i></button>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className="view-details">
                                                    <h3 className="view-name">
                                                        Description
                                                    </h3>
                                                    <p className="view-desc">{selectedBook.book_desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}




            {error ? (

                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />

                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect /> // Show loading  while data is being fetched
            ) : (
                <>

                    <div className='container-fluid'>
                        <div className='row'>



                            {fifthObject && (
                                <section className='newly_add_books' id="nutrition">
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading text-white'>{fifthObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn white-btnn" to="/newly_added_books" >
                                                    View All <i className="fas fa-long-arrow-alt-right"></i>
                                                </NavLink>
                                            </div>


                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {fifthObject.books_data && fifthObject.books_data.map(datav => (
                                                    <div className='col mb-4' key={datav._id}>
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "assets/images/elements/book_cover.jpg";
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            {/* <div className="text-div">
                                                                <button className="btn modal-view-btn">View</button>
                                                            </div> */}
                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name text-white">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}
                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))

                                                }
                                            </div>


                                        </div>
                                    </div>
                                </section>
                            )}



                            {firstObject && (
                                <section id="recommended" className='recom_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading'>{firstObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn btn-130" to="/recommended_books" autoFocus={false}>View All <i className="fas fa-long-arrow-alt-right"></i></NavLink>
                                            </div>


                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {firstObject.books_data && firstObject.books_data.map(datav => (

                                                    <div className='col mb-4' key={datav._id}>
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image ">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "assets/images/elements/book_cover.jpg";
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}

                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}

                            {secondObject && (
                                <section id="language" className='book-by-language px-0'>
                                    <div className='container space-container'>
                                        <div className='col-md-12 inner_section'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='section-heading mb-0 book-language-title'>{secondObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btn d-none" to="/books_by_language" >
                                                    <span>View All</span>
                                                </NavLink>
                                            </div>

                                            <Slider {...settings} className="brand-slider slider-arrow">
                                                {secondObject.lang_data && secondObject.lang_data.map(datav => (
                                                    <div key={datav._id} className="brand-wrap" onClick={() => handleLanguageClick(datav._id)}>
                                                        <div className="brand-media">
                                                            <h4>{datav.language}</h4>

                                                        </div>

                                                    </div>
                                                ))}
                                            </Slider>


                                        </div>
                                    </div>


                                </section>

                            )}

                            {thirdObject && (
                                <section id="popular" className='popular_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                                <h2 className='title-heading'>{thirdObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn" to="/popular_books" >
                                                    View All <i className="fas fa-long-arrow-alt-right"></i>
                                                </NavLink>
                                            </div>

                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {thirdObject.books_data && thirdObject.books_data.map(datav => (

                                                    <div className='col mb-4' key={datav._id} >
                                                        <div className='img-card book_style' onClick={() => openModal(datav)}>
                                                            <div className='product-media'>

                                                                <div className="product-image">
                                                                    <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                        <div className="df-book-wrapper">
                                                                            <div className="df-book-page1">
                                                                            </div>
                                                                            <div className="df-book-page2">
                                                                            </div>
                                                                            <div className="df-book-cover df-icon-play-popup">
                                                                                <img
                                                                                    src={datav.book_cover_img}
                                                                                    className='w-100'
                                                                                    alt="Book Cover"
                                                                                    onError={(e) => {
                                                                                        e.target.onerror = null;
                                                                                        e.target.src = "assets/images/elements/book_cover.jpg";
                                                                                    }}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>



                                                        </div>
                                                        <div className='book-content'>
                                                            <h6 className="book-name">
                                                                {datav.book_title}
                                                            </h6>
                                                            <p>
                                                                <span>Author :</span> {datav.author_name}
                                                            </p>
                                                            <div className="product-rating">
                                                                {renderStars(datav.avg_rating)}
                                                            </div>
                                                            <div className="product-rating">
                                                                <span className='rating-text'>{datav.avg_rating.toFixed(1)}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))

                                                }
                                            </div>


                                        </div>
                                    </div>
                                </section>
                            )}

                            <section id="author" className='book-by-language px-0 mt-0 featured-slider'>
                                <div className='container space-container'>
                                    <div className='col-md-12 inner_section'>
                                        <div className='d-flex justify-content-center align-items-center mb-4'>
                                            <h2 className='section-heading mb-0 book-language-title'>Featured Authors</h2>

                                        </div>

                                        <Slider {...settings} className="brand-slider slider-arrow">

                                            <div className="brand-wrap">
                                                <div className="brand-media">

                                                    <h4> <img src="assets/images/authors/AnilKumarSalil.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/ashaprasad.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/RabindranathTagore.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/KamalKishoreGoenka.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/MChidanandaMurthy.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/nandininayar.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/RachnaBholaYamini.png" alt="author" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/authors/rameshbijlani.png" alt="author" /></h4>
                                                </div>
                                            </div>

                                        </Slider>


                                    </div>
                                </div>


                            </section>

                            {fourthObject && (
                                <section id="gener" className='genre_books'>
                                    <div className='container space-container'>
                                        <div className='col-md-12'>
                                            <div className='d-flex justify-content-center align-items-center mb-4'>
                                                <h2 className='title-heading'>{fourthObject.title}</h2>
                                                <NavLink className="btn-6 view-all-btnn d-none" to="/genre_recommended">
                                                    View All
                                                </NavLink>

                                              
                                            </div>

                                            <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5'>
                                                {fourthObject.cat_data && fourthObject.cat_data.map((datav, index) => {
                                                    const staticImages = [
                                                        "assets/images/static/image1.png",
                                                        "assets/images/static/image2.png",
                                                        "assets/images/static/image3.png",
                                                        "assets/images/static/image4.png",
                                                        "assets/images/static/image5.png",
                                                        "assets/images/static/image6.png",
                                                        "assets/images/static/image7.png",
                                                        "assets/images/static/image8.png",
                                                        "assets/images/static/image9.png",

                                                    ];

                                                    return (
                                                        <div className='col' key={datav._id} onClick={() => handleGenreClick(datav._id)}>
                                                            <div className="main-div">
                                                                <div className="image-div">
                                                                    <img
                                                                        src={staticImages[index] || "assets/images/elements/books.jpg"}
                                                                        className="w-100"
                                                                        alt={datav.category_name}
                                                                    />
                                                                </div>
                                                                <div className="text-div">
                                                                    <span className='gener-name'>{datav.category_name}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        </div>
                                    </div>
                                </section>
                            )}


                            <section id="publisher" className='book-by-language px-0 mt-0 featured-slider publisher-img'>
                                <div className='container space-container'>
                                    <div className='col-md-12 inner_section'>
                                        <div className='d-flex justify-content-center align-items-center mb-4'>
                                            <h2 className='section-heading mb-0 book-language-title'>Featured Publishers</h2>

                                        </div>

                                        <Slider {...settings} className="brand-slider slider-arrow">

                                            <div className="brand-wrap">
                                                <div className="brand-media">

                                                    <h4> <img src="assets/images/publishers/AmarChitrKatha.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/DiamondBooks.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/Eklavya.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/GitaPressPublication.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/NBT.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/NCERT .png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/SCERTDelhi.png" alt="publishers" /></h4>
                                                </div>
                                            </div>
                                            <div className="brand-wrap">
                                                <div className="brand-media">
                                                    <h4> <img src="assets/images/publishers/VidyaVikasAcademy.png" alt="publishers" /></h4>
                                                </div>
                                            </div>

                                        </Slider>


                                    </div>
                                </div>


                            </section>


                            {sixObject && (
                                <section id="age_group" className='book-by-agegroup book-by-language px-0 mt-3'>
                                    <div className='container'>
                                        <div className='row justify-content-center'>
                                            <div className='col-md-8  books_age_section'>
                                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                                    <h2 className='section-heading mb-0 book-language-title'>{sixObject.title}</h2>
                                                    <NavLink className="btn-6 view-all-btn d-none" rel="noreferrer" to="/books_by_age_group" >
                                                        <span>View All</span>
                                                    </NavLink>
                                                </div>


                                                <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 justify-content-center'>
                                                    {sixObject.agegroup_data && sixObject.agegroup_data.map(datav => (

                                                        <div className='col' key={datav._id} onClick={() => handleAgeGroupClick(datav.agegroup, datav._id)}>

                                                            <div className="brand-wrap">
                                                                <div className="brand-media">
                                                                    <h4> {datav.agegroup}</h4>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    ))

                                                    }
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </section>
                            )}


                            <section id="media" className='gallery-sec d-none'>
                                <div className="container space-container">
                                    <div className='row'>
                                        <div className='col-xl-3 my-4'>
                                            <div className='col-md-12  h-100 p-4 gallery-box'>
                                                <div className=''>
                                                    <h2 className='title-heading mb-3 text-center mt-0'>Events</h2>
                                                </div>
                                                <div className="row h_450 scroll_thumb">
                                                    <div className='col-md-12'>
                                                        <div className="blog-card" >
                                                            <div className="blog-media">
                                                                <NavLink className="blog-img" href="#">
                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                </NavLink>
                                                            </div>
                                                            <div className="blog-content">
                                                                <ul className="blog-meta">
                                                                    <li>
                                                                        <i className="fas fa-calendar-alt"></i>
                                                                        <span>August 20, 2024</span>
                                                                    </li>
                                                                </ul>
                                                                <h4 className="blog-title">
                                                                    <NavLink to="#" tabIndex="0">Chinar Book Festival</NavLink>
                                                                </h4>
                                                                <p className="blog-desc">
                                                                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className="blog-card" >
                                                            <div className="blog-media">
                                                                <NavLink className="blog-img" href="#">
                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                </NavLink>
                                                            </div>
                                                            <div className="blog-content">
                                                                <ul className="blog-meta">
                                                                    <li>
                                                                        <i className="fas fa-calendar-alt"></i>
                                                                        <span>August 20, 2024</span>
                                                                    </li>
                                                                </ul>
                                                                <h4 className="blog-title">
                                                                    <NavLink to="#" tabIndex="0">Amdavad International Book Festival 2024</NavLink>
                                                                </h4>
                                                                <p className="blog-desc">
                                                                    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                        <div className='col-xl-6 my-4'>
                                            <div className='col-md-12  h-100 p-4 gallery-box social-post'>
                                                <div className='text-center'>
                                                    <h2 className='title-heading mb-3 text-center mt-0'>Social Media</h2>
                                                </div>
                                                <div className="row">

                                                    <div className="col-md-12 mb-4">
                                                        <nav className='social-tabs'>
                                                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                                <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                                                                    <div className="twitter social-icons">
                                                                        <svg id="twitter" xmlns="http://www.w3.org/2000/svg" width="15.044" height="14.08" viewBox="0 0 15.044 14.08">
                                                                            <g id="layer1" transform="translate(-281.5 -167.31)">
                                                                                <path id="path1009" d="M281.537,167.31l5.808,7.766L281.5,181.39h1.315l5.117-5.528,4.135,5.528h4.477l-6.135-8.2,5.44-5.877h-1.315l-4.713,5.091-3.808-5.091Zm1.934.969h2.057l9.081,12.142h-2.057Z" transform="translate(0 0)" fill="#414141" />
                                                                                <rect id="Rectangle_47" data-name="Rectangle 47" width="4" height="12" transform="translate(0 6.118)" fill="#414141" />
                                                                                <circle id="Ellipse_3" data-name="Ellipse 3" cx="2" cy="2" r="2" fill="#414141" />
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                                <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                                                                    <div className="social-icons insta-icon">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="17.5" viewBox="0 0 17.5 17.5">
                                                                            <g id="instagram" transform="translate(-1.25 -0.884)">
                                                                                <rect id="Rectangle_27976" data-name="Rectangle 27976" width="16" height="16" rx="5" transform="translate(2 1.634)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                                                <path id="Path_160" data-name="Path 160" d="M16,11.37A4,4,0,1,1,12.63,8,4,4,0,0,1,16,11.37Z" transform="translate(-2.199 -2.167)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                                                <line id="Line_15" data-name="Line 15" x2="0.01" transform="translate(14.115 5.518)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                                <button className="nav-link" id="nav-facebook-tab" data-bs-toggle="tab" data-bs-target="#nav-facebook" type="button" role="tab" aria-controls="nav-facebook" aria-selected="false">
                                                                    <div className="social-icons facebook-icon">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z" /></svg>
                                                                    </div>
                                                                </button>
                                                                <button className="nav-link" id="nav-youtube-tab" data-bs-toggle="tab" data-bs-target="#nav-youtube" type="button" role="tab" aria-controls="nav-youtube" aria-selected="false">
                                                                    <div className="social-icons youtube-icon">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" /></svg>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </nav>
                                                        <div className="tab-content" id="nav-tabContent">
                                                            <div className="tab-pane fade active show h_450 scroll_thumb" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                                                <div className="row ">
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>
                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>



                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>
                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>39</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>



                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane fade h_450 scroll_thumb" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                                                <div className="row">
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="tab-pane fade h_450 scroll_thumb" id="nav-facebook" role="tabpanel" aria-labelledby="nav-facebook-tab">
                                                                <div className="row">
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="tab-pane fade h_450 scroll_thumb" id="nav-youtube" role="tabpanel" aria-labelledby="nav-youtube-tab">
                                                                <div className="row">
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-12'>
                                                                        <div className="blog-card-social" >
                                                                            <div className="profile-image">
                                                                                <NavLink href="#"><img src="assets/images/user.png" alt="user" /></NavLink>
                                                                                <div className='ms-3'>
                                                                                    <span className='social-title'># Rashtriya e-Pustakalaya</span>
                                                                                    <span className='social-date'>August 20, 2024</span>
                                                                                </div>

                                                                            </div>
                                                                            <p className="blog-desc">
                                                                                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                                                                            </p>

                                                                            <div className="blog-media">
                                                                                <NavLink className="blog-img" href="#">
                                                                                    <img className='w-100' src="assets/images/elements/chinar.jpg" alt="blog" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="blog-content">
                                                                                <ul className="blog-meta">
                                                                                    <li>
                                                                                        <i className="fas fa-heart"></i>
                                                                                        <span className='like-count'>29</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-comment-dots"></i>

                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="fas fa-paper-plane"></i>

                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='col-xl-3 my-4'>
                                            <div className='col-md-12 h-100  p-4 gallery-box'>
                                                <div className='text-center'>
                                                    <h2 className='title-heading mb-3 text-center mt-0'>Gallery</h2>
                                                </div>
                                                <div className="row row-cols-2 h_450 scroll_thumb">
                                                    {images.map((image, index) => (
                                                        <div className="col thumb" key={index}>
                                                            <div className='' onClick={() => openModalg(index)}>
                                                                <a className="thumbnail" href="#!" >
                                                                    <img
                                                                        className="w-100"
                                                                        src={image.src}
                                                                        alt={image.title}
                                                                    />
                                                                </a>

                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>

                                        </div>



                                    </div>

                                </div>

                                <div
                                    className="modal fade"
                                    id="image-gallery"
                                    tabIndex="-1"
                                    role="dialog"
                                    aria-labelledby="image-gallery-title"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000" >
                                            <button className="modal-close icofont-close" data-bs-dismiss="modal"></button>

                                            <div className="product-view">
                                                <img
                                                    id="image-gallery-image"
                                                    className="img-responsive col-md-12"
                                                    src={modalImage}
                                                    alt={modalTitle}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>


                                            <button className="carousel-control-prev" type="button" onClick={showPreviousImage}>
                                                <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                                    <img src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e" alt="Arrow Icon" />
                                                </span>
                                                <span className="visually-hidden">Previous</span>
                                            </button>
                                            <button className="carousel-control-next" type="button" onClick={showNextImage}>
                                                <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                                    <img src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e" alt="Arrow Icon" />
                                                </span>
                                                <span className="visually-hidden">Next</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>


                            <section id="blog" className=" blog-part d-none">
                                <div className="container space-container">
                                    <div className="row my-4">
                                        <div className="col-12">
                                            <h2 className='title-heading text-center'>Blog</h2>
                                        </div>
                                        <div className='col-md-12 mt-3'>
                                            <Blogs />
                                        </div>
                                    </div>

                                </div>


                            </section>

                            <section id="orientation" className="orientation d-none">
                                <div className="container space-container">
                                    <div className="row my-4 justify-content-center text-center">
                                        <div className="col-12">
                                            <h2 className='title-heading text-center mb-2'>Book an online/offline orientation session</h2>
                                            <p className='orientation-description'>Want to know more about Rashtriya e-Pustakalaya</p>
                                            <NavLink className="btn-6 view-all-btnn" to="#" >
                                                <span>Register Now</span>
                                            </NavLink>
                                        </div>
                                        <div className='col-md-7 mt-3'>
                                            <Calendar />
                                        </div>
                                    </div>

                                </div>


                            </section>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}
